// extracted by mini-css-extract-plugin
export default {"searchResults":"by_gP","resultsMessage":"by_gQ","breadcrumb":"by_gR","isOpen":"by_gS","hitCount":"by_gT","hasResults":"by_gV"};